<template>
    <div class="card light-back max-content-width w-100">
        <div class="card-body">
            <div class="small-box">
                <h2>5. {{$t("Ilmumine")}}</h2>
                <div class="help-block">{{$t("Vali millal kuulutus ilmuma peaks")}}</div>

                <div class="mt-4" v-for="paper in store.stepInfo.newspapers" :key="paper.slug">
                    <div style="overflow: auto" v-if="paper.selected">
                        {{paper.name[$i18n.locale]}}
                        <span @click="addPaper(paper.slug, true)" class="fas fa-times float-right"
                              v-if="countSelected>1"></span>
                        <span class="float-right" v-if="pickedDates[paper.slug].length>0">
                                {{pickedDates[paper.slug].length}} x {{getPriceWithVAT(filterSinglePrice(paper.slug)).toFixed(2)}} €
                                = {{(pickedDates[paper.slug].length * getPriceWithVAT(filterSinglePrice(paper.slug, true))).toFixed(2)}} €
                                &nbsp;&nbsp;&nbsp;
                        </span>
                    </div>
                    <div v-if="paper.selected">
                        <div :id="'select_dates_'+paper.slug">
                            <multiselect :hide-selected="true"
                                         :multiple="true"
                                         :options="[]" :searchable="false" :show-labels="false"
                                         :showNoOptions="false" @close="showCalendar(null)" 
                                         @update:modelValue="saveState"
                                         @open="showCalendar(paper.slug)" placeholder=""
                                         v-model="selectedDates[paper.slug]">
                            </multiselect>
                        </div>

                        <div class="date-popover" v-if="isActive">
                            <BPopover
                                :id="'popover_for_'+paper.slug" 
                                :target="'select_dates_'+paper.slug"
                                placement="bottom"
                                click
                                :delay="0"
                                body-class="p-1"
                            >
                                <div>
                                    <VueDatePicker 
                                        :allowed-dates="allowedDates[paper.slug]"
                                        :model-value="pickedDates[paper.slug]"
                                        :inline="true"
                                        :monday-first="true"
                                        multiDates
                                        auto-apply
                                        :multi-dates="{
                                            dragSelect: false
                                         }"
                                        :locale="store.datepickerLocale"
                                        :time-config="{ enableTimePicker: false }"
                                        :action-row="{ showSelect: false, showCancel: false, showPreview: false }"
                                        @update:modelValue="calendarPickDate(paper.slug, $event)" 
                                        :formats="{ input: 'dd.MM.yyyy' }"
                                        input-class="form-control" 
                                    />
                                </div>
                                <table class="w-100">
                                    <tbody>
                                        <tr @click="addNextDates(paper, 1)">
                                            <td class="float-right">{{$t('Jargmine ilmumine')}}</td>
                                        </tr>
                                        <tr @click="addNextDates(paper, 5)">
                                            <td class="float-right">{{$t('Jargmised 5 ilmumist')}}</td>
                                        </tr>
                                        <tr @click="addNextDates(paper, 10)">
                                            <td class="float-right">{{$t('Jargmised 10 ilmumist')}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </BPopover>
                        </div>
                    </div>
                </div>

                <div v-if="someUnselected">
                    <div class="dropdown">
                    <span class="dropdown-toggle add-header" data-toggle="dropdown" id="addHeader">
                        + {{$t('Lisa valjaanne')}}
                    </span>
                        <div aria-labelledby="addHeader" class="dropdown-menu">
                            <a @click="addPaper(paper.slug)" class="dropdown-item"
                               v-for="paper in unSelectedPapers">{{paper.name[$i18n.locale]}}</a>
                        </div>
                    </div>
                </div>
                <h3 style="overflow: auto" v-if="totalPrice > 0">
                    <span class="float-right">Kokku: <span class="add-header">{{totalPrice}} €</span></span>
                </h3>
                <p>
                    <a @click="changeStep('payment')" class="btn btn-primary btn-block"
                       v-bind:class="{disabled:!datesPicked}">
                       <MoveForwardButton />
                    </a>
                </p>

            </div>
        </div>
    </div>
</template>

<script setup>
import { useMainStore } from '../includes/store';
import moment from 'moment';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import { toRaw, onMounted, onBeforeUpdate, onActivated, onDeactivated, computed, ref, watch } from 'vue';
import { BPopover } from 'bootstrap-vue-next';

import MoveForwardButton from './MoveForwardButton.vue';
import { useTax } from '../composables/useTax.js'

const { getPriceWithVAT } = useTax();
const store = useMainStore();

const isActive = ref(false);
const selectingCalendar = ref(null);
const selectedDates = ref({});

onMounted(() => {
    loadState();
    isActive.value = true;
    checkEmpty();
});

onBeforeUpdate(() => {
    checkEmpty();
});

onActivated(() => {
    isActive.value = true;
    checkEmpty();
});

onDeactivated(() => {
    isActive.value = false;
});
        

const addNextDates = (paper, count) => {
    console.log("Adding next dates", count);
    let sortedDates = paper.publish_dates.sort();
    for (let i = 0; i < count; i++) {
        pickDate(paper.slug, sortedDates[i], true);
    }
    saveState();
}

const filterSinglePrice = (slug, isFloat) => {
    let filteredPrice = store.singlePrices.filter(obj => {
        return obj.slug === slug;
    });
    if (filteredPrice.length > 0) {
        if (isFloat) {
            return parseFloat(filteredPrice[0].single_price);
        } else {
            return filteredPrice[0].single_price;
        }
    } else {
        return 0;
    }
}

const showCalendar = (slug) => {
    selectingCalendar.value = slug;
}

const changeStep = async (step) => {
    isActive.value = false;
    await saveState();
    store.changeStep(step);
}

const pickDate = (slug, date, noSave) => {
    expireDates();
    console.log('picking date', slug, date, noSave);
    if (!date) {
        console.log('Cannot choose this invalid date');
        return;
    }
    if (!selectedDates.value[slug]) {
        const newSelectedDates = selectedDates.value;
        newSelectedDates[slug] = [];
        console.log("Setting dates for paper " + slug);
        selectedDates.value = newSelectedDates;
    }
    let formattedDate = moment(date).format('DD.MM.YYYY');
    if (!selectedDates.value[slug].includes(formattedDate)) {
        selectedDates.value[slug].push(formattedDate);
        selectedDates.value[slug].sort((a, b) => {
            return moment(a, ['DD.MM.YYYY']) > moment(b, ['DD.MM.YYYY']);
        });
        if (!noSave) {
            saveState();
        }
    } else if (!noSave) {
        let index = selectedDates.value[slug].indexOf(formattedDate);
        if (index !== -1) {
            console.log('removing date', selectedDates.value[slug][index]);
            selectedDates.value[slug].splice(index, 1);
        }
    }
    console.log("Dates picked: ", selectedDates.value);
}

const calendarPickDate = (slug, dates) => {
    expireDates();
    const newSelectedDates = structuredClone(toRaw(selectedDates.value));
    newSelectedDates[slug] = dates.map(date => moment(date).format('DD.MM.YYYY'));

    selectedDates.value = newSelectedDates;

    console.log('dates', selectedDates.value[slug]);
}

const expireDates = () => {
    console.log("Starting Expiring dates", selectedDates.value);
    let hasChanges = false;
    let newsPapersCopy = [];

    //hide dates from selection if are expired for all selected newspapers
    store.stepInfo.newspapers.forEach((newsPaper) => {

        //Testing to see if new day has come when expire happens. Mondays paper will expire on friday.
        let expireDate = moment().add(newsPaper.lock_hours, 'hours');
        while (expireDate.isoWeekday() === 6 || expireDate.isoWeekday() === 7) {
            expireDate = expireDate.add(24, 'hours')
        }

        let paperPublishDates = [];
        newsPaper.publish_dates.forEach(date => {
            if (!expireDate.isAfter(moment(date))) {
                paperPublishDates.push(date);
            } else {
                console.log(newsPaper.slug + " expired date " + date);
                hasChanges = true;
            }
        });
        newsPaper.publish_dates = paperPublishDates;
        newsPapersCopy.push(newsPaper);
    });
    if (hasChanges) {
        store.setNewspapers(newsPapersCopy);
    }

    console.log("Expiring dates", selectedDates.value);
    //remove current dates if expired
    Object.keys(selectedDates.value).forEach((slug) => {
        Object.keys(selectedDates.value[slug]).forEach((key) => {
            let lock_hours = 0;
            store.stepInfo.newspapers.forEach(paper => {
                if (paper.slug === "slug") {
                    lock_hours = paper.lock_hours;
                }
            });

            let expireDate = moment().add(lock_hours, 'hours');
            if (expireDate.isAfter(moment(selectedDates.value[slug][key], ['DD.MM.YYYY']))) {
                console.log("Removed expired date from selected list: " + selectedDates.value[slug][key]);
                selectedDates.value[slug].splice(key, 1);
            }
        });
    });
    console.log("Finish Expiring dates", selectedDates.value);
}

const addPaper = async (paperSlug, remove) => {
    store.setIsLoading(true);
    let newsPapersCopy = store.stepInfo.newspapers;
    newsPapersCopy.forEach((newsPaper) => {
        if (newsPaper.slug === paperSlug) {
            if (remove) {
                newsPaper.selected = false;
            } else {
                newsPaper.selected = true;
            }
        }
    });

    await axios.post('/state/newspapers', {
        state: newsPapersCopy
    }).catch(_ => {
        store.sessExpired();
    });
    store.setIsLoading(false);

    store.setNewspapers(newsPapersCopy);
}

const loadState = () => {
    let dates = store.stepInfo.dates;
    if (!Array.isArray(dates.selectedDates)) {
        selectedDates.value = dates.selectedDates;
    }

    checkEmpty();
}

const saveState = async () => {
    store.setIsLoading(true);
    let postData = {
        selectedDates: selectedDates.value,
    };

    store.setDates(postData);
    await axios.post('/state/dates', {
        state: postData
    }).catch(_ => {
        store.sessExpired();
    });
    store.setIsLoading(false);
}

const checkEmpty = () => {
    if (!store.stateLoaded) {
        return;
    }
    let empty = true;
    store.singlePrices.forEach(price => {
        if (parseFloat(price.single_price) > 0) {
            empty = false;
        }
    });

    if (empty && store.step === "dates") {
        store.changeStep('adContent');
    }

    expireDates();
}
        
const countSelected = computed(() => {
    let count = 0;
    store.stepInfo.newspapers.forEach(paper => {
        if (paper.selected) {
            count++;
        }
    });
    return count;
})

const datesPicked = computed(() => {
    let allPicked = true;
    if (!store.stepInfo.newspapers) {
        return false;
    }

    //if paper is selected then at least one of the date must be chosen
    store.stepInfo.newspapers.forEach(paper => {
        if (paper.selected && (!selectedDates.value[paper.slug] || selectedDates.value[paper.slug].length === 0)) {
            allPicked = false;
        }
    });
    return allPicked;
})

const totalPrice = computed(() => {
    let total = 0;
    for (const slug in pickedDates.value) {
        total += pickedDates.value[slug].length * filterSinglePrice(slug, true);
    }
    return getPriceWithVAT(total).toFixed(2);
})

const pickedDates = computed(() => {
    let pickedDates = {};
    if (!store.stepInfo.newspapers) {
        return pickedDates;
    }
    store.stepInfo.newspapers.forEach((paper) => {
        let paperPickedDates = [];
        if (selectedDates.value[paper.slug]) {
            selectedDates.value[paper.slug].forEach(selectedDate => {
                paperPickedDates.push(moment(selectedDate, ['DD.MM.YYYY']).toDate());
            });
        }
        pickedDates[paper.slug] = paperPickedDates;
    });
    return pickedDates;
})

const someUnselected = computed(() => {
    if (!store.stepInfo.newspapers) {
        return false;
    }
    let someUnselected = false;
    store.stepInfo.newspapers.forEach((newsPaper) => {
        if (!newsPaper.selected) {
            someUnselected = true;
        }
    });
    return someUnselected;
})
const unSelectedPapers = computed(() => {
    if (!store.stepInfo.newspapers) {
        return [];
    }
    let unselected = [];
    store.stepInfo.newspapers.forEach((newsPaper) => {
        if (!newsPaper.selected) {
            unselected.push(newsPaper);
        }
    });
    return unselected;
})
const allowedDates = computed(() => {
    const map = {};
    store.stepInfo.newspapers.forEach(paper => {
        // Make a copy of allowed dates array (or convert to Date objects if you prefer)
        map[paper.slug] = paper.publish_dates.map(d => d); 
        // or to Date objects:
        // map[paper.slug] = paper.publish_dates.map(d => new Date(d));
    });

    console.log('Allowed dates array map', map);
    return map;
})

watch(() => store.stateLoaded, (loaded) => {
    if (loaded) {
        loadState();
    }
}, { immediate: true });

</script>

<style scoped>

    tr {
        cursor: pointer;
    }

</style>
